import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
} from "@backstage/theme";

import { montserratRegular } from "./fonts";



const COLORS = {
  primary: "#0084d5",
  secondary: "#082D5B",
  border: "#253a45",
  base100: "#010409",
  base200: "#0d1117",
  base300: "#243742",
  info: "#00bafe",
  infoContent: "#042e49",
  success: "#00d390",
  successContent: "#004c39",
  error: "#ff637d",
  errorContent: "#4d0218",
  warning: "#fcb700",
  warningContent: "#793205",
};

// eslint-disable-next-line max-len
const shape = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='400' height='1400' viewBox='0 0 1400 400'%3e%3crect width='100%25' height='100%25' fill='${COLORS.base200}'/%3e%3c/svg%3e")`;
const headerTheme = genPageTheme({ colors: [COLORS.base200, COLORS.base200], shape });

export const kvDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: COLORS.primary },
      border: COLORS.border,
      secondary: { main: COLORS.secondary },
      background: {
        default: COLORS.base100,
        paper: COLORS.base200,
      },
      info: { main: COLORS.info },
      infoBackground: COLORS.info,
      infoText: COLORS.infoContent,
      success: { main: COLORS.success },
      error: { main: COLORS.error },
      errorBackground: COLORS.error,
      errorText: COLORS.errorContent,
      warning: { main: COLORS.warning },
      warningBackground: COLORS.warning,
      warningText: COLORS.warningContent,
      banner: {
        info: COLORS.info,
        error: COLORS.error,
        text: "#FFFFFF",
        link: COLORS.primary,
      },
      status: {
        ...palettes.dark.status,
        ok: COLORS.success,
        error: COLORS.error,
        pending: COLORS.info,
        warning: COLORS.warning,
      },
      navigation: {
        background: COLORS.base200,
        indicator: COLORS.primary,
        color: "#ffffffc0",
        selectedColor: "#FFFFFF",
        navItem: {
          hoverBackground: "#1b1b1b",
        },
        submenu: {
          background: "#1b1b1b",
        },
      },
      tabbar: {
        indicator: COLORS.primary,
      },
      bursts: {
        fontColor: "#FEFEFE",
        slackChannelText: "#ddd",
        backgroundColor: {
          default: "#7E8C17",
        },
        gradient: {
          linear: "linear-gradient(-137deg, #3B6995 0%, #082D5B 100%)",
        },
      },
      divider: COLORS.border,
      code: { background: "#000" },
    },
    defaultPageTheme: "home",
  }),
  pageTheme: {
    home: headerTheme,
    documentation: headerTheme,
    tool: headerTheme,
    service: headerTheme,
    website: headerTheme,
    library: headerTheme,
    other: headerTheme,
    app: headerTheme,
    apis: headerTheme,
    card: headerTheme,
  },
  fontFamily: montserratRegular.fontFamily,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": [montserratRegular],
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: `1px solid ${COLORS.border}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: `1px solid ${COLORS.border}`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.base300,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardInfo: { color: COLORS.infoContent, backgroundColor: COLORS.info },
        standardSuccess: { color: COLORS.successContent, backgroundColor: COLORS.success },
        standardWarning: { color: COLORS.warningContent, backgroundColor: COLORS.warning },
        standardError: { color: COLORS.errorContent, backgroundColor: COLORS.error },
      },
    },
    BackstageWarningPanel: {
      styleOverrides: {
        panel: {
          color: COLORS.errorContent,
          backgroundColor: COLORS.error,
        },
        summaryText: {
          color: COLORS.errorContent,
        },
        details: {
          color: COLORS.errorContent,
        },
        message: {
          color: COLORS.errorContent,
        },
        summary: {
          color: COLORS.errorContent,
        },
      },
    },
    BackstageHeaderTabs: {
      styleOverrides: {
        tabsWrapper: {
          backgroundColor: COLORS.base100,
        },
      },
    },
    CatalogReactUserListPicker: {
      styleOverrides: {
        root: {
          border: "unset",
          backgroundColor: "unset",
          padding: "0",
        },
        groupWrapper: {
          margin: "0",
        },
        title: {
          "display": "block",
          "marginLeft": "0",
          "marginTop": "20px",
          "&:first-child": {
            marginTop: "0",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: COLORS.border,
        },
      },
    },
    BackstageTableHeader: {
      styleOverrides: {
        header: {
          borderColor: COLORS.border,
          borderBottomColor: COLORS.border,
        },
      },
    },
    BackstageSelectInputBase: {
      styleOverrides: {
        input: {
          borderColor: COLORS.border,
        },
      },
    },
    PluginCatalogEntityLinksEmptyState: {
      styleOverrides: {
        code: {
          backgroundColor: "#000",
        },
      },
    },
  },
});